enum CompanyRoutes {
  List = '/companies',
  Edit = '/companies/edit/:id',
  Add = '/companies/add',
}

export default CompanyRoutes
